module.exports = __webpack_public_path__ + "img/navLogo.eda6963a.png";